interface SEOData {
  title: string;
  description: string;
  keywords: string;
  canonicalUrl: string;
  ogType?: string;
  ogImage?: string;
  schema?: Record<string, unknown>;
}

export default function SEOHelmet({ data }: { data: SEOData }) {
  const jsonLd = data.schema ? JSON.stringify(data.schema) : null;

  return (
    <>
      <title>{data.title}</title>
      <meta name="description" content={data.description} />
      <meta name="keywords" content={data.keywords} />
      <link rel="canonical" href={data.canonicalUrl} />

      <meta property="og:title" content={data.title} />
      <meta property="og:description" content={data.description} />
      <meta property="og:type" content={data.ogType || 'website'} />
      <meta property="og:url" content={data.canonicalUrl} />
      {data.ogImage && <meta property="og:image" content={data.ogImage} />}
      <meta property="og:locale" content="zh_CN" />
      <meta property="og:site_name" content="777影院" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={data.title} />
      <meta name="twitter:description" content={data.description} />
      {data.ogImage && <meta name="twitter:image" content={data.ogImage} />}

      {jsonLd && (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: jsonLd }}
        />
      )}
    </>
  );
}